import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { TRANSLATIONS, normalizeLang } from './translations';

const LocaleContext = createContext(null);

export function LocaleProvider({ children, initialLang = 'ru', onLanguageChange }) {
  const [lang, setLangState] = useState(() => normalizeLang(initialLang));

  useEffect(() => {
    setLangState(normalizeLang(initialLang));
  }, [initialLang]);

  const setLang = useCallback(
    async (next) => {
      const resolved = normalizeLang(next);
      setLangState(resolved);
      try {
        await onLanguageChange?.(resolved);
      } catch (_) {
        /* keep UI language even if API fails */
      }
    },
    [onLanguageChange]
  );

  const t = useCallback(
    (key, vars) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS.ru;
      let text = dict[key] ?? TRANSLATIONS.ru[key] ?? key;
      if (vars && typeof text === 'string') {
        Object.entries(vars).forEach(([k, v]) => {
          text = text.replace(`{${k}}`, String(v));
        });
      }
      return text;
    },
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, t }), [lang, setLang, t]);
  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const ctx = useContext(LocaleContext);
  if (!ctx) throw new Error('useLocale outside provider');
  return ctx;
}
